const getCart = state => state.cart
const getCheckout = state => state.checkout

export default {
    getCart,
    getCheckout
}